import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { cssVar } from 'src/app/styles/helper';
import styled from 'styled-components';

export const PricingCardContainer = styled(Stack)`
  width: 100%;
  height: 100%;
`;

export const HighlightLabel = styled(Stack)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${cssVar('spacing-6xl')};
`;
